import { c as _c } from "react/compiler-runtime";
import { useDebounce } from "@utils/time-utils";
import { useState } from "react";

/** Debounce interval in milliseconds */
export const SEARCH_DEBOUNCE_TIME = 300;
/** Returns the debounced search text and whether it is currently in debounce situation or not */
export function useDebouncedSearchText(t0) {
  const $ = _c(7);
  const {
    searchText
  } = t0;
  const [isDebouncingSearch, setIsDebouncingSearch] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = function debouncingStartCallback() {
      setIsDebouncingSearch(true);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const debouncingStartCallback = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = function debouncingEndCallback() {
      setTimeout(() => {
        setIsDebouncingSearch(false);
      }, 50);
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const debouncingEndCallback = t2;
  const t3 = useDebounce(searchText, SEARCH_DEBOUNCE_TIME, debouncingStartCallback, debouncingEndCallback);
  let t4;
  if ($[2] !== t3) {
    t4 = t3.trim();
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const debouncedSearchText = t4;
  let t5;
  if ($[4] !== debouncedSearchText || $[5] !== isDebouncingSearch) {
    t5 = {
      isDebouncingSearch,
      debouncedSearchText
    };
    $[4] = debouncedSearchText;
    $[5] = isDebouncingSearch;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
}